import React from 'react';
import { connect } from 'react-redux';

import LINK from 'constants/link.const';
import QST from 'constants/quickSetupType.const';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';
import asObject from 'utils/objects/asObject.util';

import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';

import QuickSetupType from './QuickSetupType';

class QuickSetupTypeWrap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isFooterButtonActive: false, active: 0 };
  }

  UNSAFE_componentWillMount() {
    const normalFlow =
      asObject(this.props.location.state).normalFlow || fromPropsToQuery(this.props).normalFlow === 'true';
    if (!normalFlow) {
      navFor('QuickSetupTypeWrap.onFooterButtonClicked()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onFooterButtonClicked = () => {
    const { isFooterButtonActive, active } = this.state;

    if (!isFooterButtonActive) {
      return;
    }

    const state =
      // eslint-disable-next-line no-nested-ternary
      active === 1
        ? { quickSetupType: QST.hair, normalFlow: true }
        : active === 2
          ? { quickSetupType: QST.beauty, normalFlow: true }
          : { normalFlow: true };

    navFor('QuickSetupTypeWrap.onFooterButtonClicked()', this.props).push({
      pathname: LINK.onboardingSalon,
      state,
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), ...state }),
    });
  };

  handleOptionClick = (active) => void this.setState({ active }, () => void this.checkButton());
  checkButton = () => void this.setState({ isFooterButtonActive: this.state.active !== 0 });

  render() {
    const { isFooterButtonActive, active } = this.state;
    return (
      <div data-bem="QuickSetupTypeWrap" className="content-wrap">
        <HeaderContainer
          titleFirstPart="Which services does your salon offer?"
          userName=""
          titleSecondPart=""
          description=""
          backBtnCallBack={() => void navFor('QuickSetupTypeWrap.render()', this.props).push(LINK.onboardingType)}
        />
        <QuickSetupType onOptionClick={this.handleOptionClick} active={active} />
        <OnboardingFooter
          isFooterButtonActive={isFooterButtonActive}
          onButtonClick={this.onFooterButtonClicked}
          isLoading={false}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentSalon: state.currentSalon,
});

export default connect(mapStateToProps)(QuickSetupTypeWrap);
